let previousRespId;


const sendInventoryIssue = async () => {
  let item = document.getElementById('prd_invtry_issue_nieukwoop--js');
  let atc_btn = item.parentElement.querySelector('form .product-form__buttons button');
  let prd_form_elm = item.parentElement.querySelector('product-form');
  let stock;
  let startTime = performance.now();

  // prd_id: parseInt(item.dataset.id),
  // var_id: parseInt(item.dataset.varId),

  const raw = {
    sku: item.dataset.sku,
    tag: item.dataset.isNieukwoop == 'true' ? 'nieuwkoop' : 'other'
  };

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(raw),
  };

  try {
    const response = await fetch("https://flowersandplantsmall.com/api/inventory-get-stock.php", requestOptions);
    let result = await response.text();
    result = JSON.parse(result);
    stock = result.stock;

    if(stock == 0){
      atc_btn.setAttribute('disabled', 'true');
      atc_btn.innerHTML = "Sold out";
    }else if(stock > 0 && atc_btn.disabled == true){
      atc_btn.removeAttribute('disabled', 'false');
      atc_btn.innerHTML = "Add to cart";
      prd_form_elm.nextElementSibling.style.display = 'none';
    }

    if(stock != null && stock != undefined ){
      let raw2 = {...raw, stock: stock}
      const requestOptions2 = { ...requestOptions, body: JSON.stringify(raw2)};
  
      const response2 = await fetch("https://flowersandplantsmall.com/api/inventory-shopify-update.php", requestOptions2);
      let result2 = await response2.text();
      result2 = JSON.parse(result2);
    }else{ console.log('Not a Nieuwkoop Product') }
    
  } catch (error) {
    console.error("Error:", error);
  }

  let endTime = performance.now(); // End timer //{startTime,endTime}
  console.log(`Time taken to Fetch Stock: ${((endTime - startTime).toFixed(2) / 1000 ).toFixed(2)} s`);
};
 

document.addEventListener('DOMContentLoaded', () => {
  if(window.location.href.includes('/products/')){ sendInventoryIssue() }
})


// ai chat box


// const openBtn = document.getElementById("aichat-openChatBtn");
const floatingBtn = document.getElementById("aichat-floatingBtn");
const overlay = document.getElementById("aichat-overlay");
const closeBtn = document.getElementById("aichat-closeBtn");
// const sendBtn = document.getElementById("aichat-sendBtn");
// const input = document.getElementById("aichat-input");
const content = document.getElementById("aichat-content");

const showChat = () => {
  overlay.classList.remove("aichat-hidden");
  // document.body.classList.add('chat-bot-open')
}
const hideChat = () => {  
  overlay.classList.add("aichat-hidden");
  // document.body.classList.remove('chat-bot-open')
  const reactModalSheetContainer = document.querySelector(".react-modal-sheet-container");
  if(reactModalSheetContainer){
    const parentDiv = reactModalSheetContainer?.closest("div");
    if(parentDiv){
      parentDiv.classList.remove('hidden');
    }
  }
}
// openBtn.addEventListener("click", showChat);
floatingBtn.addEventListener("click", showChat)
closeBtn?.addEventListener("click", hideChat);

// async function handleSend() {
//   const msg = input.value.trim();
//   if (!msg) return;
//   addMessage(msg, true);
//   input.value = "";
//   showLoading(true);
//   const reply = await getAIReply(msg);
//   showLoading(false);
//   addMessage(reply, false);

//   // const data = await fetch('http://localhost/test.php', {
//   //   method:"GET",
//   //   headers : {
//   //     "content-type" : "application/json"
//   //   }
//   // }); 
  
// }

// function showLoading(status){
//   if(status){
//     const html = `<div id="typing-indicator" class="typing-indicator" >
//       <span></span><span></span><span></span>
//     </div>`
//     addMessage(html, false)
//   }else{
//     document.getElementById('typing-indicator')?.remove();
//   }
// }

function overlayHandler(e){
  const aichatBox = e.target.closest('#aichat-box');
  if(!aichatBox){
    hideChat();
  }
  
}


async function getAIReply(input) {
  console.log(previousRespId,'previouse reap id here...');
  
  try {
    const lowerInput = input.toLowerCase();

    const res = await fetch('https://aa.miraclewebsoft.com/api/open-ai', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ prompt: lowerInput, prevRespId: previousRespId }),
    });

    if (!res.ok) {
      const errorData = await res.json();
      return 'Unknown error from API';
    }

    const data = await res.json();
    previousRespId = data?.prevRespId;

    return data?.response || 'No response received.';
  } catch (error) {
    console.log('error', error)
    return `Network or server error: ${error.message}`;
  }
}




 const suggestions = [
      "How often should I water my Monstera?",
      "What houseplants are best for low light?",
      "Which plants are safe for pets?",
      "How do I propagate a String of Hearts?"
    ];

    const suggestionsContainer = document.getElementById("chatSuggestions");
    const messagesContainer = document.getElementById("chatMessages");
    const chatMinScreenCon = document.querySelector(".chat-min-h-screen");
    const form = document.getElementById("chatForm");
    const chatFormPrdPage = document.getElementById("chatInputForm");
    const input = document.getElementById("chatInput");
    const chatInputPrdPage = document.getElementById("chatInputPrdPage");

    let isLoading = false;

    suggestions.forEach((question) => {
      const btn = document.createElement("button");
      btn.className = "chat-suggestion-btn";
      btn.textContent = question;
      btn.onclick = () => handleSendMessage(question);
      suggestionsContainer.appendChild(btn);
    });

    async function handleSendMessage(text, fromPrdPage) {
      if (!text.trim() || isLoading) return;
      document.getElementById('chatSuggestions')?.classList?.add("hidden");
      
      let userInp;
      if(fromPrdPage){
        userInp = `${text} (${window.location.href})`;
        chatInputPrdPage.value = "";
        messagesContainer.innerHTML = "";
        previousRespId = "";
      }else{
        userInp = text;
      }

      addMessage(text, true);
      input.value = "";
      isLoading = true;


      const loadingEl = document.createElement("div");
      loadingEl.className = "chat-msg-ai";
      loadingEl.innerHTML = `
        <div class="chat-bubble chat-bubble-ai chat-thinking">
          <div class="chat-dot"></div>
          <div class="chat-dot"></div>
          <div class="chat-dot"></div>
        </div>`;
      messagesContainer.appendChild(loadingEl);
      chatMinScreenCon.scrollTop = chatMinScreenCon.scrollHeight;

      
      const reply = await getAIReply(userInp);
        loadingEl.remove();
        addMessage(reply, false);
          isLoading = false;
      // setTimeout(() => {
      // }, 2000);
      }

    function addMessage(text, isUser) {
      const messageWrapper = document.createElement("div");
      messageWrapper.className = isUser ? "chat-msg-user" : "chat-msg-ai";

      const bubble = document.createElement("div");
      bubble.className = `chat-bubble ${isUser ? "chat-bubble-user" : "chat-bubble-ai"}`;
      bubble.innerHTML = isUser ? text : marked.parse(text);  // parse markdown to HTML;

      messageWrapper.appendChild(bubble);
      messagesContainer.appendChild(messageWrapper);
      // messagesContainer.scrollTop = messagesContainer.scrollHeight;
      chatMinScreenCon.scrollTop = chatMinScreenCon.scrollHeight;

    }

    // function getPlantAdvice(question) {
    //   const lower = question.toLowerCase();
    //   if (lower.includes('monstera') && lower.includes('water')) {
    //     return "Monsteras prefer to dry out between waterings. Water when the top 1-2 inches of soil feel dry...";
    //   } else if (lower.includes('low light')) {
    //     return "Great low-light houseplants include: Snake plants, ZZ plants, Pothos, Peace lilies...";
    //   } else if (lower.includes('safe') && lower.includes('pets')) {
    //     return "Pet-safe plants include: Spider plants, Boston ferns, Parlor palms...";
    //   } else if (lower.includes('string of hearts') && lower.includes('propagate')) {
    //     return "String of Hearts is super easy to propagate...";
    //   }
    //   return "I'd be happy to help with your plant care question! Could you provide more details?";
    // }

    form.onsubmit = (e) => {
      e.preventDefault();
      handleSendMessage(input.value);
    };

    if(chatFormPrdPage){
      chatFormPrdPage.onsubmit = (e) =>{
        e.preventDefault();
        showChat();
        handleSendMessage(chatInputPrdPage.value, true);
      }
    }

function showTerms(show){
  const chatTermsContent = document.querySelector('.chat-terms-content')
  if(show){
    chatTermsContent?.classList?.remove('hidden')
  }else{
    chatTermsContent?.classList?.add('hidden')
  }
}

function inputFocusHanler(elm) {
  // setTimeout(() => {
  //   elm.scrollIntoView({ behavior: 'smooth', block: 'center' });
  // }, 300);

  const reactModalSheetContainer = document.querySelector(".react-modal-sheet-container");
  if(reactModalSheetContainer){
    const parentDiv = reactModalSheetContainer?.closest("div");
    if(parentDiv){
      parentDiv.classList.add('hidden');
    }
  }
}

document.addEventListener("DOMContentLoaded", function() {
  console.log('dkdkdk....');
  
  function showChatBotAfterLoadingMobile() {
    const chatBotMobileIconContainer = document.querySelector(".chat-bot-mobile-icon-container");
    if(chatBotMobileIconContainer){
      chatBotMobileIconContainer.querySelector('.chat-div-menu-loading')?.classList.add("hidden");
      chatBotMobileIconContainer.querySelector('.header__icon')?.classList.remove("hidden");
    } 
  }
  
  let intervalID = setInterval(checkForModal, 2000);
  let timeoutID = setTimeout(forceStop, 12000);

  function checkForModal() {
    
    const reactModalSheetContainer = document.querySelector('.react-modal-sheet-container');
    const giftboxFirstVisit = sessionStorage.getItem("giftbox-first-visit");

    if (reactModalSheetContainer || giftboxFirstVisit) {
        
      clearInterval(intervalID);
      clearTimeout(timeoutID);
      setTimeout(()=>{        
        showChatBotAfterLoadingMobile();
      }, 1600)
    }
  }

  function forceStop() {
    clearInterval(intervalID); // just in case it wasn't cleared
    showChatBotAfterLoadingMobile();
  }

  function callOpenAiPopup() {
    const aiButton = document.querySelector(".leafyai-custom-button .button");
    if(aiButton){
      aiButton.addEventListener("click", (e) =>{
        e.preventDefault();
        showChat()
      });
    }
  }
  callOpenAiPopup();
});



// window.handleFreeGift = () => {
//   let timeout;
//   return async (cart) => {
//     clearTimeout(timeout);
//     timeout = setTimeout(() => {

//       let qualifiedGiftIds = [];
//       const addToCart = [];
//       const cartSubtotal = cart?.items_subtotal_price / 100;
      
//       const giftItems = Array.from(document.querySelectorAll('.pb-product-item-main[fgvid]')).map(el => ({
//         id: Number(el.getAttribute('fgvid')),
//         limit: Number(el.querySelector('[fgl]')?.getAttribute('fgl') || 0)
//       }));

//       giftItems.forEach(gift => {
//         if (gift.limit === 0 || cartSubtotal >= gift.limit) {
//           qualifiedGiftIds.push(gift.id);
//           console.log(`🔔 Gift ID ${gift.id} is eligible based on limit only (limit: ${gift.limit})`);
//         }
//       });

//       console.log('Gift Items:', giftItems);
//       console.log('Cart Subtotal:', cartSubtotal);
//       console.log('cart:', cart);



//       const cartItemIds = cart?.items?.map(item => item.id) || [];
//       qualifiedGiftIds = qualifiedGiftIds.filter(id => !cartItemIds.includes(id));

//       console.log('qualifiedGiftIds', qualifiedGiftIds);

//       if (qualifiedGiftIds.length > 0) {
//         let data = {
//           items: []
//         };

//         qualifiedGiftIds?.forEach(id => {
//           data.items.push({
//             id: id,
//             quantity: 1,
//             properties: {
//               _ctm_free_gift: true
//             }
//           });
//         });

//         await freeGiftAddToCart(data);
//       }


        
//       // if (cart?.items.length > 0) {
//       //   const freeGiftMatches = giftItems.filter(g => g.limit === 0);
//       //   freeGiftMatches.forEach(freeGift => {
//       //     if (!qualifiedGiftIds.includes(freeGift.id)) {
//       //       addToCart.push(freeGift.id);
//       //     }
//       //   });
//       // }



//       // Final qualified free gift IDs array
//       // console.log('Qualified Free Gift IDs:', qualifiedGiftIds);






//     }, 500);
//   };
// };


// const freeGiftAddToCart = (item) => {
//   try {
//     const response = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//       },
//       body: JSON.stringify(item)
//     });

//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }

//     const data = await response.json();
//     console.log('✅ Added to cart:', data);
//     return data;
//   } catch (error) {
//     console.error('❌ Add to cart failed:', error);
//   }
// }


window.handleFreeGift = (() => {
  let timeout;

  return async (cart) => {
    clearTimeout(timeout);

    timeout = setTimeout(async () => {

      if (!cart) cart = await freeGiftFetchCart();

      const cartPage = window.location.href.includes('/cart');
      let qualifiedGiftIds = [];
      let removedGiftsId = [];
      const addToCart = [];

      const freeGiftPrices = cart.items.filter(item => item.properties && item.properties._ctm_free_gift === true).reduce((sum, item) => sum + item.final_price, 0);
      // console.log("freeGiftPrices", freeGiftPrices);

      const cartSubtotal = (cart?.items_subtotal_price - freeGiftPrices)/ 100;
      // console.log("cartSubtotal", cartSubtotal);

      const giftItems = Array.from(document.querySelectorAll('.pb-product-item-main[fgvid]')).map(el => ({
        id: Number(el.getAttribute('fgvid')),
        limit: Number(el.querySelector('[fgl]')?.getAttribute('fgl') || 0)
      }));

      giftItems.forEach(gift => {        
        if ((gift.limit === 0 && cart?.items.length > 0 ) || cart?.items.length > 0 && cartSubtotal >= gift.limit) qualifiedGiftIds.push(gift.id);
        else removedGiftsId.push(gift.id);
      });


      // console.log('cart:', cart);
      const cartItemIds = cart?.items?.map(item => item.id) || [];

      qualifiedGiftIds = qualifiedGiftIds?.filter(id => !cartItemIds.includes(id));
      if (qualifiedGiftIds.length > 0) {
        await freeGiftAddToCart(qualifiedGiftIds);
        cartPage && window.location.reload();
        return;
      }

      removedGiftsId = removedGiftsId?.filter(id => cartItemIds.includes(id));
      if (removedGiftsId.length > 0){
        const removedGiftsKeys = cart?.items.filter(item => removedGiftsId.includes(item.id)).map(item => item.key);
        await removeCartItems(removedGiftsKeys);
        cartPage && window.location.reload()
        return;
      }

      if (cart?.items.length >= 1) {
        const allFreeGiftExist = cart.items.every(item => {
          const properties = item?.properties || {};
          return Object.keys(properties).some(key => key.includes('_ctm_free_gift'));
        });
        if (allFreeGiftExist) {
          await fraaGiftClearCart();
          cartPage && window.location.reload();
        }
      }


    }, 800);
  };
})();


// ✅ Make sure this function is async
const freeGiftAddToCart = async (qualifiedGiftIds) => {

  let data = {
    items: []
  };

  qualifiedGiftIds.forEach(id => {
    data.items.push({
      id: id,
      quantity: 1,
      properties: {
        _ctm_free_gift: true
      }
    });
  });

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    await response.json();
    const cart = await freeGiftFetchCart();
    await halo.updateSidebarCart(cart);

  } catch (error) {
    console.error('❌ Add to cart failed:', error);
  }
};


const freeGiftFetchCart = async () => {
  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`❌ Cart fetch failed: ${response.status}`);
    }

    const cart = await response.json();
    return cart;

  } catch (error) {
    console.error('❌ Error fetching cart:', error);
    return null;
  }
};


const removeCartItems = async (itemKeys = [], clearCart = false) => {
  try {
    if (!Array.isArray(itemKeys) || itemKeys.length === 0) {
      console.warn('⚠️ No item keys provided for removal.');
      return;
    }

    const updates = {};
    itemKeys.forEach(key => {
      updates[key] = 0;
    });

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (!response.ok) {
      throw new Error(`❌ Cart update failed: ${response.status}`);
    }

    const result = await response.json();
    const cart = await freeGiftFetchCart();
    await halo.updateSidebarCart(cart);

  } catch (error) {
    console.error('❌ Error removing items:', error);
  }
};


async function fraaGiftClearCart() {
  try {
    const response = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const cart = await freeGiftFetchCart();
    await halo.updateSidebarCart(cart);

  } catch (error) {
    console.error('❌ Failed to clear cart:', error);
  }
}
